/* Mouse-drag navigation for slideshow sliders.
   Touch swipe already works natively (scroll-snap slider); this adds the same
   gesture for desktop pointers. Styles live in paw-redesign.css (.is-dragging). */
(function () {
  var DRAG_THRESHOLD = 6;

  /* Anything inside a slide that is meant to be clicked owns its own pointer.
     Starting a drag from the call-to-action turned the cursor into a grab
     and, past six pixels of unintended movement, swallowed the click that
     followed — so pressing the button felt like it did nothing.
     .btn is listed alongside a/button because the visible slide button is a
     wrapper div with the link inside it. */
  var NO_DRAG = 'a, button, input, select, textarea, label, .btn, [role="link"], [role="button"]';

  function isInteractive(target) {
    return target && target.closest && target.closest(NO_DRAG);
  }

  function initDrag(slider) {
    if (slider.dataset.pawDrag) return;
    slider.dataset.pawDrag = 'true';

    var isDown = false;
    var moved = false;
    var startX = 0;
    var startScroll = 0;

    slider.addEventListener('mousedown', function (e) {
      if (isInteractive(e.target)) return;
      isDown = true;
      moved = false;
      startX = e.pageX;
      startScroll = slider.scrollLeft;
      slider.classList.add('is-dragging');
    });

    document.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      var dx = e.pageX - startX;
      if (Math.abs(dx) > DRAG_THRESHOLD) moved = true;
      if (moved) {
        slider.scrollLeft = startScroll - dx;
        e.preventDefault();
      }
    });

    document.addEventListener('mouseup', function () {
      if (!isDown) return;
      isDown = false;

      if (moved) {
        var slides = slider.querySelectorAll('.slider__slide');
        var nearest = null;
        var minDist = Infinity;
        slides.forEach(function (slide) {
          var dist = Math.abs(slide.offsetLeft - slider.scrollLeft);
          if (dist < minDist) {
            minDist = dist;
            nearest = slide;
          }
        });
        if (nearest) slider.scrollTo({ left: nearest.offsetLeft, behavior: 'smooth' });
        // keep snap disabled until the smooth scroll settles
        setTimeout(function () {
          slider.classList.remove('is-dragging');
        }, 450);
      } else {
        slider.classList.remove('is-dragging');
      }
    });

    // a real drag must not trigger the slide's link
    slider.addEventListener(
      'click',
      function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );

    slider.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });
  }

  function initAll() {
    document.querySelectorAll('slideshow-component .slider').forEach(initDrag);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
